/**
 * Which start of a lesson is the current one. A lesson starts through awaits (leaving VR, fetching a
 * package's height map); the class may end, or the teacher push another, meanwhile. Each start takes a
 * ticket, every leave bumps the counter, and a start that finds its ticket stale after an await does
 * nothing more: it builds no lesson and tells the session nothing.
 */
export class Generation {
  #now = 0;

  /** A new start: the ticket it checks after each await. Stales every older one. */
  begin(): number {
    return ++this.#now;
  }

  /** The lesson was left or the class ended: every ticket so far is stale. */
  leave(): void {
    this.#now++;
  }

  current(ticket: number): boolean {
    return ticket === this.#now;
  }
}
